(() => {
  const script = document.currentScript;
  const termsPrefix = script?.dataset.termsPrefix;
  const termsLinkLabel = script?.dataset.termsLinkLabel;

  if (!termsPrefix || !termsLinkLabel) return;

  const selector = '.tos-app-extension .agreement__container label';

  const localizeTermsLabel = (label) => {
    if (label.dataset.vvLocalized === 'true') return;

    const link = label.querySelector('a');
    if (!link) return;

    link.textContent = termsLinkLabel;
    label.replaceChildren(
      document.createTextNode(`${termsPrefix} `),
      link,
      document.createTextNode('.'),
    );
    label.dataset.vvLocalized = 'true';
  };

  const localizeTermsLabels = (root = document) => {
    if (root instanceof Element && root.matches(selector)) {
      localizeTermsLabel(root);
    }

    root.querySelectorAll?.(selector).forEach(localizeTermsLabel);
  };

  const start = () => {
    localizeTermsLabels();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) localizeTermsLabels(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', (event) => localizeTermsLabels(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
